<template>
  <div v-if="sortedEvents.length" class="section_event">
    <template v-for="({status, eventData}) of sortedEvents">
      <template v-if="eventData.length">
        <carousel-component
            :key="status"
            v-if="!mobileView"
            :item-data="eventData"
            :max-per-line="eventData.length"
            :scrolled-quantity="2"
            :autoscroll-delay="0"
            :min-item-width="280"
            :max-item-width="380"
            :integer-items-quantity="false"
            class="d-flex flex-column gap-1"
        >
          <template v-slot:before>
            <div class="w-100 d-flex justify-content-between flex-grow-1 align-items-center mr-3
          carousel-title"
            >
              <span>{{ $t($options.carouselData[status].title) }}</span>
              <app-link
                  :to="pageUrl(status)"
                  class="carousel-button"
              >
                {{ $t('ViewMore') }}
              </app-link>
            </div>
          </template>
          <template v-slot:default="{ props }">
            <div :key="props.id" class="px-2 py-2">
              <c-w-event-card :event="props"/>
            </div>
          </template>
        </carousel-component>
        <div v-else
             :key="`${status}_else`"
        >
          <h2 class="my-4 text-title text-left">{{ $t($options.carouselData[status].title) }}</h2>
          <c-w-event-card
              v-for="event in eventData.slice(0, $options.MAX_CARDS_FOR_MOBILE)"
              :event="event"
              :key="event.id"
          />
          <app-link :to="pageUrl(status)" class="more-button__black mt-3">
            <div>
              {{ $t('More') }}
            </div>
          </app-link>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import {mapCacheActions} from 'vuex-cache';
import {GET_HOME_PAGE_EVENTS} from '@/store/actionTypes';
import AppLink from '../../../components/base-components/AppLink';
import CarouselComponent from '../../../components/base-components/CarouselComponent';
import CWEventCard from '../EventCards/EventCard_v2.vue';
import {STREAM_STATUS} from '@/const';
import {LIVE, UPCOMING, VOD} from '@/pages';

export default {
  name: 'EventMainSection',
  components: {
    CWEventCard,
    CarouselComponent,
    AppLink,
  },
  props: {
    categories: {
      type: Array,
    },
    participants: {
      type: Array,
    },
    canProcessRequest: {
      type: Boolean,
      default: true,
    },
  },
  CAROUSEL_AUTOSCROLL_SPEED: 5000,
  MAX_CARDS_FOR_MOBILE: 3,
  data() {
    return {
      events: {},
      mobileView: false,
      requestParams: {
        limit: 12,
      },
    };
  },
  inject: {
    watchFoViewChanges: 'watchFoViewChanges',
  },
  carouselData: {
    [STREAM_STATUS.live]: {
      title: 'Live events',
      page: LIVE,
    },
    [STREAM_STATUS.upcoming]: {
      title: 'Upcoming events',
      page: UPCOMING,
    },
    [STREAM_STATUS.vod]: {
      title: 'On-demand',
      page: VOD,
    },
  },
  statusSort: [STREAM_STATUS.live, STREAM_STATUS.upcoming, STREAM_STATUS.vod],
  methods: {
    ...mapCacheActions({
      homeEvents: GET_HOME_PAGE_EVENTS,
    }),
    pageUrl(status) {
      return {
        path: this.$options.carouselData[status].page.path,
        query: this.$route.query,
      };
    },
    makeRequest() {
      if (!this.canProcessRequest) return;

      const params = Object.assign({}, this.requestParams);
      if (this.categories) {
        params.categories = this.categories;
        params.recursively_categories = 1;
      }
      if (this.participants) {
        params.participant_groups = this.participants;
        params.recursively_participant_groups = 1;
      }
      this.homeEvents(params).then(({data}) => {
        this.events = data;
      });
    },
  },
  watch: {
    categories() {
      this.makeRequest();
    },
    participants() {
      this.makeRequest();
    },
    canProcessRequest() {
      this.makeRequest();
    },
  },
  mounted() {
    this.makeRequest();
    const unsubscribeCb = this.watchFoViewChanges((isMobile) => {
      this.mobileView = isMobile;
    });
    this.$once('hook:beforeDestroy', unsubscribeCb);
  },
  computed: {
    sortedEvents() {
      const sortedArray = [];
      this.$options.statusSort.forEach((status) => {
        this.events[status]?.data?.length &&
        sortedArray.push({
          status,
          eventData: this.events[status]?.data,
        });
      });
      return sortedArray;
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/css/colors";
@import "src/assets/css/mixins";

.is-notmobile {
  @include media-max(xs) {
    display: none;
  }
}

.is-mobile {
  @include media-min(xs) {
    display: none;
  }
}

h2.text-title {
  color: var(--settings-body-text-color);
  font-weight: bold;
  letter-spacing: 0;
  line-height: 1;
  font-style: normal;
  font-size: clamp(1.4rem, 7vw, 2rem);
}

.carousel-title {
  font-style: normal;
  a {
    text-transform: none;
  }
}

.carousel-button {
  font-weight: 700;
  font-size: 1.2rem;
  color: var(--settings-body-text-color);

  &:hover {
    color: var(--settings-body-text-color);
    text-decoration: none;
  }
}

.section_event {
  padding: 1rem 3rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
}
</style>
